/** グリッド表示/リスト表示. */
export const CHANGE_GRID_LIST = "CHANGE_GRID_LIST";
